{
  "version": 1,
  "asset_id": "9759f6a3-a98e-4276-baca-c741f40cdc7d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/9759f6a3-a98e-4276-baca-c741f40cdc7d/svc-analytics-reporting-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/9759f6a3-a98e-4276-baca-c741f40cdc7d/svc-analytics-reporting-640.webp",
  "original_filename": "svc-analytics-reporting-640.webp",
  "size": 9162,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:42Z"
}
